import { prepareIconsLinksToSave } from "../helpers/file.helper";
import { WhitelabelAndroidConfig } from "../models/whitelabel-android-config";


export default class WhitelabelAndroidConfigFactory {

    private whitelabelAndroidConfig: WhitelabelAndroidConfig = new WhitelabelAndroidConfig();

    public constructor(){}

    public withStatus(status: number) {
        this.whitelabelAndroidConfig.status = status;
        return this;
    }

    public withPackageName(packageName: string | null): WhitelabelAndroidConfigFactory {
        this.whitelabelAndroidConfig.packageName = packageName;
        return this;
    }
    
    public withName(name: string): WhitelabelAndroidConfigFactory {
        this.whitelabelAndroidConfig.name = name;
        return this;
    }

    public withSha256CertificateFingerPrint(sha256: string | null) {
        this.whitelabelAndroidConfig.sha256CertificateFingerPrint = sha256;
        return this;
    }

    public withIntentScheme(intentScheme: string): WhitelabelAndroidConfigFactory {
        this.whitelabelAndroidConfig.intentScheme = intentScheme;
        return this;
    }

    public withKeytool(fileLink: string | null) {
        this.whitelabelAndroidConfig.keytoolLink = fileLink;
        return this;
    }

    public withStore(fileLink: string | null) {
        this.whitelabelAndroidConfig.storeLink = fileLink;
        return this;
    }

    public withIcons(filesLink: string | null) {
        if (!filesLink) return this;

        const icons = prepareIconsLinksToSave(filesLink);
        this.whitelabelAndroidConfig.iconsLinks = icons;
        return this;
    }

    public withAppIcon(fileLink: string | null) {
        this.whitelabelAndroidConfig.appIconLink = fileLink;
        return this;
    }

    public withServiceAccountPrivateKey(value: string | null) {
        this.whitelabelAndroidConfig.serviceAccountPrivateKey = value;
        return this;
    }

    public withServiceAccountEmail(value: string | null) {
        this.whitelabelAndroidConfig.serviceAccountEmail = value;
        return this;
    }

    public withGoogleServiceJson(fileLink: string | null) {
        this.whitelabelAndroidConfig.googleServicesJsonLink = fileLink;
        return this;
    }

    public build() {
        return this.whitelabelAndroidConfig;
    }
}